function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Cookies from 'js-cookie';
import { renderVIPSelect } from '@biotrust/ada-component-library';
import '../snippets/product-info-area';
import '../snippets/yotpo-pictures-widget';
import { initProductData, initOneThreeSixPDPFlavorSelector, initVIPFlavorSelector } from '../biotrust/flavorSelector/index';
import { getOverrideProductSellingPlanId } from '../biotrust/flavorSelector/utils';
import { createClient, queryProductByHandle } from '../biotrust/storefrontApi';
import { trackersPush } from '../biotrust/trackers/utils';
import '../../styles/templates/product.1_3_6_SNS_FLAVOR_V3.scss';

var _ref = window.bt || {},
    _ref$settings = _ref.settings;

_ref$settings = _ref$settings === void 0 ? {} : _ref$settings;
var _ref$settings$storefr = _ref$settings.storefrontApiToken;
_ref$settings$storefr = _ref$settings$storefr === void 0 ? {} : _ref$settings$storefr;
var priceTestApiToken = _ref$settings$storefr.priceTests;

var _ref2 = window.Shopify || {},
    shopifyDomain = _ref2.shop;

console.debug('Loading product.1_3_6_SNS_Flavor_V3.js');

function getProductOverrideData() {
  return _getProductOverrideData.apply(this, arguments);
}

function _getProductOverrideData() {
  _getProductOverrideData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref4,
        overrideProductHandle,
        _ref4$defaultSNSFrequ,
        defaultSNSFrequency,
        client,
        productOverride,
        sellingPlanId,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, overrideProductHandle = _ref4.overrideProductHandle, _ref4$defaultSNSFrequ = _ref4.defaultSNSFrequency, defaultSNSFrequency = _ref4$defaultSNSFrequ === void 0 ? 4 : _ref4$defaultSNSFrequ;

            if (overrideProductHandle) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", null);

          case 3:
            _context.prev = 3;
            console.debug('[Price Test] querying product override data');
            client = createClient(shopifyDomain, priceTestApiToken);
            _context.next = 8;
            return queryProductByHandle(client, overrideProductHandle);

          case 8:
            productOverride = _context.sent;
            console.debug('[Price Test] product override data fetched', {
              productOverride: productOverride
            });

            if (productOverride) {
              sellingPlanId = getOverrideProductSellingPlanId(productOverride, defaultSNSFrequency);
              productOverride.sellingPlanId = parseInt(sellingPlanId === null || sellingPlanId === void 0 ? void 0 : sellingPlanId.split('/').pop(), 10);
              productOverride.variants.forEach(function (variant) {
                var _variant$id, _variant$sellingPlanA, _snsPriceAdj$adjustme;

                variant.id = parseInt((_variant$id = variant.id) === null || _variant$id === void 0 ? void 0 : _variant$id.split('/').pop(), 10);
                variant.price = Math.floor(variant.priceV2.amount) * 100;

                var _ref5 = ((_variant$sellingPlanA = variant.sellingPlanAllocations.find(function (sp) {
                  return sp.id === sellingPlanId;
                })) === null || _variant$sellingPlanA === void 0 ? void 0 : _variant$sellingPlanA.priceAdjustments) || [],
                    _ref6 = _slicedToArray(_ref5, 1),
                    snsPriceAdj = _ref6[0];

                variant.snsDiscountPercent = (snsPriceAdj === null || snsPriceAdj === void 0 ? void 0 : (_snsPriceAdj$adjustme = snsPriceAdj.adjustmentValue) === null || _snsPriceAdj$adjustme === void 0 ? void 0 : _snsPriceAdj$adjustme.adjustmentPercentage) || 0;
                variant.snsDiscountDollar = Math.round(Number(variant.priceV2.amount) * (variant.snsDiscountPercent / 100));
                variant.snsPriceDollar = Number(variant.priceV2.amount) - variant.snsDiscountDollar;
              });
            }

            return _context.abrupt("return", productOverride);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            console.error('[Price Test]', _context.t0);
            return _context.abrupt("return", null);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 14]]);
  }));
  return _getProductOverrideData.apply(this, arguments);
}

function displayProductOverrideData(productData, productOverrideData) {
  var _defaultVariant$price;

  if (!productData || !productOverrideData) {
    return;
  }

  var _productOverrideData$ = _slicedToArray(productOverrideData.variants, 1),
      defaultVariant = _productOverrideData$[0];

  var buy3Discount = 0;
  var buy6Discount = 0;
  var discountTag = productOverrideData.tags.find(function (el) {
    return el.includes('Tiered_Discount');
  });

  if (discountTag) {
    var arr = discountTag.split('_');
    buy3Discount = isNaN(Number(arr[0])) ? 0 : Number(arr[0]);
    buy6Discount = isNaN(Number(arr[1])) ? 0 : Number(arr[1]);
  }

  var buy1price = parseInt(defaultVariant === null || defaultVariant === void 0 ? void 0 : (_defaultVariant$price = defaultVariant.priceV2) === null || _defaultVariant$price === void 0 ? void 0 : _defaultVariant$price.amount, 10);
  var oneTimePricing = {
    1: buy1price,
    3: buy1price - buy3Discount,
    6: buy1price - buy6Discount
  };
  $('meta[itemprop="price"]').attr('content', buy1price);
  $('[data-cyp="one-time"]').each(function (index, elem) {
    var _$$text;

    var $elem = $(elem).unwrap('.pricingwrapper');
    var $container = $elem.parents('.grid__item-136innertable:first').addClass('price-test');
    var perPackageText = " Per ".concat(productData.metadata.packageType);
    var originalPriceHtml = '';

    if (elem.dataset.qty === '1') {
      perPackageText = '';
      originalPriceHtml = "\n        <span class=\"original-price\">\n          Original Price:\n          <strike aria-hidden=\"true\">$".concat(Math.round(productData.price / 100), "</strike>\n        </span>\n      ");
    }

    var price = oneTimePricing[elem.dataset.qty];

    if (typeof price === 'undefined') {
      console.error("Unknown one-time price element quantity '".concat(elem.dataset.qty, "'"), elem);
    } else {
      $elem.text("$".concat(price).concat(perPackageText));
    }

    $('.each', $container).remove();
    $elem.before(originalPriceHtml, '<span class="reduced-price">REDUCED PRICE:</span>');
    var savingsText = (_$$text = $('.savings', $container).text()) === null || _$$text === void 0 ? void 0 : _$$text.trim();
    var savingsPercent = Math.floor((1 - price / buy1price) * 100);
    $('.savings', $container).text(savingsText === null || savingsText === void 0 ? void 0 : savingsText.replace('Save', 'Save Additional').replace(/\d+/, savingsPercent));
    $('span, div', $container).wrapAll('<div></div>');
  });
  $('[data-cyp="sns"]').each(function (index, elem) {
    var $elem = $(elem);
    $elem.parents('.grid__item-136innertable:first').addClass('price-test');

    if (elem.dataset.priceType === 'compare-at') {
      var html = "\n        <span class=\"original-price-sns\">\n          Original Price:\n          <strike aria-hidden=\"true\">$".concat(Math.round(productData.price / 100), "</strike>\n        </span>\n        <span class=\"reduced-price-sns\">\n          Reduced Price:\n          <strike aria-hidden=\"true\">$").concat(Math.round(defaultVariant.price / 100), "</strike>\n        </span>\n      ");
      $elem.unwrap();
      $elem.replaceWith(html);
    } else if (elem.dataset.priceType === 'price') {
      $(elem).text('$' + defaultVariant.snsPriceDollar);
    } else if (elem.dataset.priceType === 'discount-price') {
      $(elem).hide();
    } else if (elem.dataset.priceType === 'discount-percent') {
      $(elem).text(defaultVariant.snsDiscountPercent + '%');
    }
  });
}

function renderCYP(productData, productOverrideData) {
  var buy1SnsContainer = document.getElementById('btOneThreeSix__Buy1SnsButton');
  var buy3SnsContainer = document.getElementById('btOneThreeSix__Buy3SnsButton');
  var buy6SnsContainer = document.getElementById('btOneThreeSix__Buy6SnsButton');
  initOneThreeSixPDPFlavorSelector({
    buy1Container: document.getElementById('btOneThreeSix__Buy1Button'),
    buy3Container: document.getElementById('btOneThreeSix__Buy3Button'),
    buy6Container: document.getElementById('btOneThreeSix__Buy6Button'),
    buy1SnsContainer: buy1SnsContainer,
    buy3SnsContainer: buy3SnsContainer,
    buy6SnsContainer: buy6SnsContainer,
    buy1SnsSellingPlanId: Number(buy1SnsContainer.dataset.sellingPlanId),
    buy3SnsSellingPlanId: Number(buy3SnsContainer.dataset.sellingPlanId),
    buy6SnsSellingPlanId: Number(buy6SnsContainer.dataset.sellingPlanId),
    rootElement: document.getElementById('PageContainer'),
    product: productData,
    productOverride: productOverrideData
  });
}

function initPriceSplitTest(productData) {
  console.debug('[Price Test] setting up bail out timeout');
  var bailTimeout = new Promise(function (resolve) {
    return setTimeout(resolve, 2000);
  });
  var waitOnProductOverride = getProductOverrideData(productData.metadata);
  var determineSplitTestPath = new Promise(function (resolve) {
    if (productData.metadata.experimentId) {
      // Allow forcing the test path by setting a localStorage value -- key: {experimentId}.1 value: true
      if (window.localStorage.getItem("".concat(productData.metadata.experimentId, ".1")) === 'true') {
        resolve(true);
        return;
      }

      trackersPush(function (trackers) {
        // eslint-disable-next-line shopify/prefer-early-return
        trackers.subscribe({
          topic: 'experiment',
          handler: function handler(_ref3) {
            var experimentId = _ref3.experimentId,
                experimentVariation = _ref3.experimentVariation;

            if (experimentId === productData.metadata.experimentId) {
              console.debug('[Price Test] split test detected', {
                experimentId: experimentId,
                experimentVariation: experimentVariation
              });
              resolve(parseInt(experimentVariation, 10) >= 1);
            }
          }
        });
      });
    } else {
      console.debug('[Price Test] no price split test exists for this product');
      resolve(false);
    }
  });
  return Promise.race([determineSplitTestPath, bailTimeout]).then(function (isTestPath) {
    return isTestPath ? waitOnProductOverride : Promise.resolve();
  });
}

function renderForVIP(productData) {
  var _window$bt, _window$bt$productsMe;

  var unitPrice = productData.price / 100; // eslint-disable-next-line func-style

  var onSelection = function onSelection(selected) {
    return $('#addtocartform input[name="quantity"]').val(selected.value);
  };

  var packageType = (_window$bt = window.bt) === null || _window$bt === void 0 ? void 0 : (_window$bt$productsMe = _window$bt.productsMetaMap[productData.id]) === null || _window$bt$productsMe === void 0 ? void 0 : _window$bt$productsMe.packageType;
  var container = document.getElementById('vipSelect'); // eslint-disable-next-line no-warning-comments
  // FIXME: lazy loading the VIPSelect component results in a Slate build error in style-tags.liquid
  // const {renderVIPSelect} = await import('@biotrust/ada-component-library');

  renderVIPSelect(unitPrice, packageType, '1', onSelection, container);

  if (productData.isOneThreeSixFlavor) {
    initVIPFlavorSelector({
      buyButtonContainer: document.getElementById('btFlavorSelector__vipBuyButton'),
      quantityInput: $('#addtocartform input[name="quantity"]')[0],
      rootElement: document.getElementById('PageContainer'),
      product: productData
    });
  }
}

function setCYPCookie(cypSelection) {
  try {
    Cookies.set('cyp-opt', cypSelection, {
      expires: 14
    });
  } catch (err) {
    console.error(err);
  }
}

$(function () {
  var _window$bt2, _window$bt2$customer;

  $('body').addClass('SNS_1_3_6');
  var productData = initProductData();

  if ((_window$bt2 = window.bt) !== null && _window$bt2 !== void 0 && (_window$bt2$customer = _window$bt2.customer) !== null && _window$bt2$customer !== void 0 && _window$bt2$customer.isVIP) {
    renderForVIP(productData);
  } else if (productData.isOneThreeSixFlavor) {
    // eslint-disable-next-line promise/catch-or-return
    initPriceSplitTest(productData).then(function (overrideData) {
      console.debug( // eslint-disable-next-line promise/always-return
      "[Price Test] rendering Choose Your Package with ".concat(overrideData ? 'override' : 'default', " pricing"), {
        overrideData: overrideData
      });
      displayProductOverrideData(productData, overrideData);
      renderCYP(productData, overrideData);
    })["catch"](function (err) {
      console.error('[Price Test]', err);
      renderCYP(productData);
    })["finally"](function () {
      $('#addtocartform').removeClass('async-hide');
    });
  }

  var cypRadioSelector = 'input:radio[name="purchase_type"]';
  var $cypOptions = $(cypRadioSelector);
  var cypActiveClass = 'rc_block__type--active'; // toggle between one-time purchase and sns

  $cypOptions.change(function (evt) {
    switch (evt.target.value) {
      case 'onetime':
        $('#cypOneTime').addClass(cypActiveClass);
        $('#cypAutoDeliver').removeClass(cypActiveClass);
        $('#rc_block__type__onetime__qty').css({
          display: 'table'
        });
        $('#rc_block__type__autodeliver__qty').css({
          display: 'none'
        });
        break;

      case 'autodeliver':
        $('#cypAutoDeliver').addClass(cypActiveClass);
        $('#cypOneTime').removeClass(cypActiveClass);
        $('#rc_block__type__onetime__qty').css({
          display: 'none'
        });
        $('#rc_block__type__autodeliver__qty').css({
          display: 'table'
        });
        break;

      default:
        console.warn('Unknown choose your package option: ' + evt.target.value);
    }
  }).prop('disabled', false); // select the appropriate radio button based on cyp override settings

  var cypSelection;
  var urlParams = new URLSearchParams(window.location.search);

  switch (urlParams.get('cyp')) {
    case 'otp':
      cypSelection = 'onetime';
      setCYPCookie(cypSelection);
      break;

    case 'sns':
      cypSelection = 'autodeliver';
      setCYPCookie(cypSelection);
      break;

    default:
      try {
        cypSelection = Cookies.get('cyp-opt');
      } catch (err) {
        console.error(err);
      }

  }

  if (cypSelection) {
    console.log('Setting cyp type from querystring or cookie:', cypSelection);
    $cypOptions.filter("[value=\"".concat(cypSelection, "\"]")).prop('checked', true).trigger('change');
  } // for ADA keyboard navigation


  $('#cypOneTime, #cypAutoDeliver').on('keydown', function (evt) {
    if (evt.which !== 13) {
      return;
    }

    if ($(evt.target).hasClass('rc_popup__trigger')) {
      evt.stopPropagation();
      return;
    }

    $(cypRadioSelector, evt.currentTarget).trigger('click');
    $('div[tabindex]:visible, .btFlavorSelector__chooseButton:visible', '#rc_block__type__onetime__qty, #rc_block__type__autodeliver__qty').first().focus();
    evt.preventDefault();
  }); // make SNS help icon keyboard accessible

  $('.rc_popup__trigger').on('focusin focusout keyup', function (evt) {
    var displayVal = 'block';

    if (evt.type === 'focusout' || evt.type === 'keyup' && evt.key === 'Escape') {
      displayVal = '';
    }

    $(evt.currentTarget).parents('.rc_popup__hover').first().find('.rc_popup__block').css('display', displayVal);
  });
});